import { render } from "./FpRadioGroup.vue?vue&type=template&id=2c7e46c6&scoped=true"
import script from "./FpRadioGroup.vue?vue&type=script&lang=js"
export * from "./FpRadioGroup.vue?vue&type=script&lang=js"

import "./FpRadioGroup.vue?vue&type=style&index=0&id=2c7e46c6&scoped=true&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c7e46c6"]])

export default __exports__